import React from 'react'
import ReactSelect from './ReactSelect'
import { names, ucFirst, unslufigy } from '../../../helpers/StringHelper'
import { isArray } from '../../../helpers/DataHelper'
import {endOfURL} from "../../../helpers/UrlHelper";

class SelectField extends React.Component
{


    placeholder()
    {
        let { placeholder, name, label,message } = this.props;
        if ( placeholder ) return placeholder;
        if ( label ) return label;
        else {
            if ( name ) {
                let _label = unslufigy( name );
                if ( name.includes(`_id`)) _label = ucFirst( name.split(`_id`)[0] );
                return _label;
            }
        }
    }

    labelText()
    {
        let { label, name } = this.props;
        if ( label ) return label;
        else {
            if ( name ) {
                let _label = unslufigy( name );
                if ( name.includes(`_id`)) _label = ucFirst( name.split(`_id`)[0] );
                return _label
            }
        }
    }

    optionLabel(o, customLabel, _label)
    {
        return customLabel
            ? `${ucFirst(o[customLabel[0]])} ( ${o[customLabel[1]]} )`
            : o[_label || `name`];
    }

    onChange = (selected) =>
    {
        let { onChange, name } = this.props;
        onChange({ target: { name, value: selected ? selected.value : `` } });
    };

    render()
    {
        let {
            options, name, _value, _label, disabled, value, noLabel,_customLabel,
            required, errors, processing, formGroupStyle,message
        } = this.props;
        let errorsPresent = errors && errors.length;
        let serverErrorsPresent = message && message.length;
        let customLabel = _customLabel && _customLabel.split(',');
        let newValue =  ((typeof value === `string` || typeof value === `number`) && value !== '') ? String(value) : undefined;

        let selectOptions = options && isArray(options)
            ? options.map((o) => ({
                value: String(o[_value || `id`]),
                label: this.optionLabel(o, customLabel, _label),
            }))
            : [];

        let selectedOption = selectOptions.find((o) => o.value === newValue) || null;

        return (

            <div className={ names(
                `form-group`,
                `animated fadeIn faster`,
                (message && message.length || errors && errors.length) && `has-error`,
                required && `required`,
                processing && `processing`) }
                style={ formGroupStyle }
            >

                <ReactSelect name={ name }
                        value={ selectedOption }
                        isDisabled={ disabled }
                        isClearable
                        placeholder={ `Select ${this.placeholder()}` }
                        options={ selectOptions }
                        onChange={ this.onChange }
                        label={ noLabel ? null : this.labelText() }
                        noFormGroup />

                {endOfURL()==="featureblock"?
                    <div className={ names(`label-text error-msg`, serverErrorsPresent && `has-error`, `animated fadeIn faster`) }>
                        { serverErrorsPresent ? message[0].message + '.' : null }
                    </div>:null}
                    {endOfURL()==="featureblock"?
                    <div className={ names(`label-text error-msg`, errorsPresent && `has-error`, `animated fadeIn faster`) }>
                        { errorsPresent ? errors[0].message + '.' : null }
                    </div>:null}

            </div>

        )
    }
}
export default SelectField;
